import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgStepCheck = ({ ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={12} fill="none" {...props}>
    <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="m13 1.089-8.571 10-3.429-4" />
  </svg>
);
export default SvgStepCheck;
